import React from "react";

import type { FC, SVGAttributes } from "react";

export const AnnouncementIcon: FC<SVGAttributes<SVGElement>> = (props) => {
  return (
    <svg viewBox="1 0 17 16" fill="none" {...props}>
      <path
        d="M5.20726 4.58594C3.71246 4.58594 2.5 5.82349 2.5 7.35057C2.5 8.8763 3.71246 10.1139 5.20726 10.1139H5.67299V14.2031C5.67299 14.4267 5.84978 14.6071 6.06879 14.6071H8.4792C8.69821 14.6071 8.875 14.4267 8.875 14.2031V4.98993C8.875 4.76639 8.69821 4.58594 8.4792 4.58594H5.20726Z"
        stroke="currentColor"
        strokeWidth="1.4"
      />
      <path
        d="M14.6941 1.47172C12.9984 2.90365 11.0387 3.95193 8.9375 4.54496V9.95655C11.0387 10.5496 12.9984 11.5979 14.6941 13.0298C14.944 13.2405 15.3125 13.0501 15.3125 12.7123V7.71681V6.78335V1.79053C15.3125 1.45281 14.944 1.26234 14.6941 1.47308V1.47172Z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinejoin="bevel"
      />
    </svg>
  );
};
